// src/components/settings/SettingsPassword.jsx
import React, { useState } from "react";
import { updatePassword } from "../Stores/profileStore";

const SettingsPassword = () => {
  const [form, setForm] = useState({
    current: "",
    next: "",
    confirm: "",
  });
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("info");

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage(null);

    if (form.next !== form.confirm) {
      setMessage("La confirmación no coincide con la nueva contraseña.");
      setMessageType("error");
      return;
    }

    const result = updatePassword(form.current, form.next);
    if (!result.success) {
      setMessage(result.error || "No se pudo actualizar la contraseña.");
      setMessageType("error");
      return;
    }

    setMessage("Contraseña actualizada correctamente (demo).");
    setMessageType("success");
    setForm({ current: "", next: "", confirm: "" });
  };

  return (
    <div className="profile-settings">
      <div className="profile-header-title">
        <h1>Cambiar contraseña</h1>
      </div>

      <form className="profile-form" onSubmit={handleSubmit}>
        <div className="profile-form-row">
          <label className="profile-label">Contraseña actual</label>
          <input
            type="password"
            className="profile-input"
            value={form.current}
            onChange={handleChange("current")}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Nueva contraseña</label>
          <input
            type="password"
            className="profile-input"
            value={form.next}
            onChange={handleChange("next")}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Confirmar nueva contraseña</label>
          <input
            type="password"
            className="profile-input"
            value={form.confirm}
            onChange={handleChange("confirm")}
          />
        </div>

        {message && (
          <div
            className={
              "profile-message " +
              (messageType === "error"
                ? "profile-message-error"
                : "profile-message-success")
            }
          >
            {message}
          </div>
        )}

        <div className="profile-actions">
          <button type="submit" className="qe-btn qe-btn-primary">
            Guardar contraseña
          </button>
        </div>
      </form>
    </div>
  );
};

export default SettingsPassword;
